import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import { useVendor } from '../contexts/VendorContext';

const PendingApproval: React.FC = () => {
  const { t } = useTranslation();
  const { user, vendor, fetchProfile } = useVendor();
  const [checking, setChecking] = useState(false);
  // A store that was approved before and is now inactive was deactivated by an admin
  const deactivated = !!vendor?.approved_at && !vendor?.is_active;

  const recheck = async () => {
    setChecking(true);
    await fetchProfile();
    setChecking(false);
  };

  return (
    <Layout>
      <div className="max-w-xl mx-auto bg-white shadow rounded-lg p-6 sm:p-8 text-center space-y-4">
        <div className="mx-auto w-14 h-14 rounded-full bg-orange-100 flex items-center justify-center">
          <svg className="w-7 h-7 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
          {deactivated ? t('pending.deactivatedTitle') : t('pending.title')}
        </h1>
        <p className="text-sm text-gray-700">
          {t(deactivated ? 'pending.deactivatedBody' : 'pending.body', { name: user?.first_name || vendor?.name || user?.username || '' })}
        </p>
        <p className="text-xs text-gray-500">{t('pending.contact')}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <button
            onClick={recheck}
            disabled={checking}
            className="px-4 py-2.5 rounded-md bg-blue-600 text-white text-sm font-medium min-h-[44px] disabled:opacity-50"
          >
            {checking ? t('common.loading') : t('pending.checkAgain')}
          </button>
          <Link to="/profile" className="px-4 py-2.5 rounded-md border border-gray-300 text-sm font-medium text-gray-700 min-h-[44px] flex items-center justify-center">
            {t('nav.profile')}
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default PendingApproval;
